/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2022-07-07 14:08:41
 * @LastEditors: linxi
 * @LastEditTime: 2022-07-11 10:55:03
 */

export interface OnlyOrgaztion {
  id: string
  name: string

  // 助记码
  mnemonicCode: string

  // icds
  icds: string

  // 空或者0:普病；1:特病；2:慢病
  category: number
}

export function fromJson(
  json: { id?: number } & Record<string, never>
): OnlyOrgaztion {
  return {
    id: json.id?.toString() || '',
    name: json.name,
    mnemonicCode: json.mnemonicCode,
    icds: json.icds,
    category: json.categorym,
  }
}

export function getFlag(flag: number) {
  switch (flag) {
    case 0:
      return '所有机构'
    case 1:
      return '医保机构'
    case 2:
      return '指定机构'
    default:
      return '-'
  }
}



export function getState(state: number) {
  switch (state) {
    case 0:
      return '未读'
    case 1:
      return '已读'
    case 2:
      return '-'
    default:
      return '-'
  }
}

export function getadviseState(adviseState: number) {
  switch (adviseState) {
    case 0:
      return '未生效'
    case 1:
      return '生效中'
    case 2:
      return '已过期'
    default:
      return '-'
  }
}
